import { Component, Input } from '@angular/core';

@Component({
  selector: 'show-error',
  templateUrl: './show-error.component.html',
  styleUrls: ['./show-error.component.scss']
})
export class ShowErrorComponent {
  @Input() errorCode;

  constructor() { }

}
